{
  "name": "prestador",
  "version": "main-1.44.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "test": "npm run test:prod",
    "test:watch:coverage": "ng test --source-map=true --code-coverage=true",
    "test:prod": "ng test --watch=false --no-watch --browsers ChromeHeadlessNoSandbox --code-coverage",
    "lint": "ng lint",
    "lint:prod": "ng lint --fix",
    "e2e": "ng e2e",
    "e2e:headless": "ng e2e --headless --watch false",
    "cypress:open": "cypress open",
    "cypress:run": "cypress run",
    "build:pro": "ng build --configuration production",
    "build:hml": "ng build --configuration stage",
    "build:dev": "ng build --configuration development"
  },
  "engines": {
    "node": "^22"
  },
  "private": true,
  "dependencies": {
    "@angular-devkit/core": "^21.2.18",
    "@angular/animations": "^21.2.17",
    "@angular/cdk": "^21.2.14",
    "@angular/common": "^21.2.17",
    "@angular/compiler": "^21.2.17",
    "@angular/core": "^21.2.17",
    "@angular/forms": "^21.2.17",
    "@angular/material": "^21.2.14",
    "@angular/platform-browser": "^21.2.17",
    "@angular/platform-browser-dynamic": "^21.2.17",
    "@angular/router": "^21.2.17",
    "@angular/service-worker": "^21.2.17",
    "@bugsnag/js": "^8.6.0",
    "@bugsnag/plugin-angular": "^8.6.0",
    "@clmeida/ngxdatepicker": "^1.9.5",
    "@dintecom/ngx-currency": "^21.0.0",
    "@iconscout/unicons": "^3.0.6",
    "@ngrx/store": "^21.0.1",
    "@swimlane/ngx-charts": "^23.1.0",
    "@types/url-join": "^4.0.3",
    "angularx-qrcode": "^21.0.5",
    "firebase": "^12.7.0",
    "ngrx-store-localstorage": "^20.1.0",
    "ngx-infinite-scroll": "^21.0.0",
    "ngx-mask": "^20.0.3",
    "ngx-toastr": "^18.0.0",
    "ngx-ui-tour-md-menu": "^15.0.3",
    "node-forge": "^1.4.0",
    "rxjs": "~7.8.0",
    "slugify": "^1.6.6",
    "tslib": "^2.6.2",
    "url-join": "^5.0.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-eslint/builder": "21.1.0",
    "@angular-eslint/eslint-plugin": "21.1.0",
    "@angular-eslint/eslint-plugin-template": "21.1.0",
    "@angular-eslint/schematics": "21.1.0",
    "@angular-eslint/template-parser": "21.1.0",
    "@angular/build": "^21.2.18",
    "@angular/cli": "^21.2.18",
    "@angular/compiler-cli": "^21.2.17",
    "@cypress/schematic": "^2.5.2",
    "@faker-js/faker": "^8.4.1",
    "@types/d3-array": "^3.2.1",
    "@types/d3-ease": "^3.0.2",
    "@types/d3-interpolate": "^3.0.4",
    "@types/d3-scale": "^4.0.8",
    "@types/d3-selection": "^3.0.10",
    "@types/d3-shape": "^3.1.6",
    "@types/d3-transition": "^3.0.8",
    "@types/jasmine": "~5.1.4",
    "@types/node": "^20.10.5",
    "@types/node-forge": "^1.3.14",
    "@typescript-eslint/eslint-plugin": "^7.9.0",
    "@typescript-eslint/parser": "^7.9.0",
    "cypress": "^13.13.0",
    "eslint": "^8.57.0",
    "jasmine-core": "~5.1.1",
    "jasmine-spec-reporter": "~7.0.0",
    "karma": "~6.4.2",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "miragejs": "^0.1.48",
    "prettier": "^3.1.1",
    "ts-node": "~10.9.2",
    "typescript": "~5.9.3"
  },
  "overrides": {
    "picomatch": "4.0.4",
    "minimatch": "3.1.4",
    "undici": "7.30.1",
    "vite": "7.3.5",
    "esbuild": "0.28.1",
    "ajv": "8.18.0",
    "lodash": "4.18.0",
    "@iconscout/unicons": {
      "axios": "^1.7.8",
      "nth-check": "^2.1.1",
      "css-what": "^6.2.2"
    },
    "karma": {
      "http-proxy": {
        "follow-redirects": "^1.16.0"
      }
    },
    "ngx-ui-tour-md-menu": {
      "@angular/core": "^21.0.0",
      "@angular/material": "^21.0.0",
      "@angular/cdk": "^21.0.0",
      "@angular/common": "^21.0.0"
    },
    "@swimlane/ngx-charts": {
      "@angular/common": "^21.0.0",
      "@angular/core": "^21.0.0",
      "@angular/cdk": "^21.0.0",
      "@angular/forms": "^21.0.0",
      "@angular/localize": "^21.0.0",
      "@angular/animations": "^21.0.0",
      "@angular/platform-browser": "^21.0.0",
      "@angular/platform-browser-dynamic": "^21.0.0"
    }
  }
}
